//const PATH = 'sys/dict/data?dictCodes='   //字典
// 前期全局设计的字典列表包 可考虑删除
export default [
    {
        url: "car/index?limit=100",       //字典url      
        out: 'carlist',       //输出key
    },
    // {
    //     url: 'accuser/all',          //原告
    //     out: 'accuser'
    // },
    // {
    //     url: 'court/index?limit=1000&page=1',          //法院
    //     out: 'court'
    // },
];